
import { useEffect } from 'react'

import TerminosCondiciones from 'components/text/TerminosCondiciones';

import { useHistory } from "react-router-dom";
import useAuthContext from "hooks/useAuthContext";

import { LAYOUT_PUBLICO, PATH_LOGIN } from "const/CommonConst";

export default function Default() {	
	useEffect(() => document.title = `Taurel - Servicios en Línea - Terminos y Condiciones de Uso`,[]);
	
	const history = useHistory();

	const {isAuthenticate, checkExpired, logout} = useAuthContext();
  
	useEffect(async () => {
	  if (!isAuthenticate || await checkExpired()){
		  logout();
		  history.push(`${LAYOUT_PUBLICO}${PATH_LOGIN}`);
	  }
	}, []); 
	
    
	return (
		<TerminosCondiciones includePadding />
	);
}
